import { render, staticRenderFns } from "./PrintForm.vue?vue&type=template&id=20fcf377&"
import script from "./PrintForm.vue?vue&type=script&lang=js&"
export * from "./PrintForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports